/**
 * Validate number value
 * @param value
 * @param min
 * @param max
 * @param defaultValue
 */
export function validateNumber(value: any, min: number, max: number, defaultValue: number): number {
    if (value && typeof value === 'number') {
        if (value < min) {
            return min;
        }
        if (value > max) {
            return max;
        }
        return value;
    }
    return defaultValue;
}
